import { formatDateStandar } from "../../../../helpers/utils";

export interface FormatterContext {
  listClients: { id: string; name: string }[];
}

/**
 * Resuelve el ID de un cliente a su nombre.
 * Si no se encuentra, devuelve el ID como fallback.
 */
export function formatClientId(
  clientId: string,
  listClients: { id: string; name: string }[]
): string {
  const client = listClients.find((c) => c.id === clientId);
  return client?.name ?? clientId;
}

/**
 * Formatea el valor de una celda del reporte según el tipo de campo.
 * Centraliza la lógica de renderizado que antes estaba dispersa en ternarios anidados.
 *
 * @param field  - Nombre del campo (columna)
 * @param row    - Fila completa de datos
 * @param context - Dependencias externas necesarias (ej: lista de clientes)
 * @returns Valor formateado (string o ReactNode para arrays)
 */
export function formatReportCell(
  field: string,
  row: Record<string, any>,
  context: FormatterContext
): React.ReactNode {
  const value = row[field];

  switch (field) {
    // -- Campos de fecha (dd/MM/yyyy | hh:mm a) --
    case "startDatetime":
    case "lastUpdate":
    case "datetimeCoreId":
      return formatDateStandar(value);

    // -- Array de asignados actuales --
    case "currentAssignees":
      if (Array.isArray(value) && value.length > 0) {
        return value.map((item: string, index: number) => (
          <span key={index}>{item}</span>
        ));
      }
      return "";

    // -- ID de cliente -> nombre legible --
    case "clientId":
      return formatClientId(value, context.listClients);

    // -- Valor genérico (números, strings, booleanos) --
    default:
      return value != null ? String(value) : "";
  }
}
